import BaseModel from './base-model.js'
import { useSettings } from '@store/settings'
const $settings = useSettings()

class Transaction extends BaseModel {
    /**
     * Set the title of the model
     */
    title = $settings.labels.payment?.singular

    /**
     * Set the id of the model
     */
    route = 'transaction'

    /**
     * Primary key of the model
     *
     * @var {string}
     */
    primaryKey = 'transaction_id'
}

export default Transaction